<template>
    <div class="p-grid">
        <!-- EXPORT ASSET DATA REF -->
        <DataTable style="display: none;" ref="siteAssets" :value="latestAssets" sortField="pass" :sortOrder="1" :loading="assetExportLoading">
            <template #loading>
                Loading activity data. Please wait.
            </template>
            <Column field="meta.asset_id" header="ID">
                <template #body="slotProps">
                    {{ slotProps.data.meta.asset_id }}
                </template>
            </Column>
            <Column field="meta.location" header="Location">
                <template #body="slotProps">
                    {{ slotProps.data.meta.location }}
                </template>
            </Column>
            <Column field="meta.area" header="Area">
                <template #body="slotProps">
                    {{ slotProps.data.meta.area }}
                </template>
            </Column>
            <Column field="meta.category" header="Category">
                <template #body="slotProps">
                    {{ slotProps.data.meta.category }}
                </template>
            </Column>
            <Column field="meta.make" header="Make" sortable>
                <template #body="slotProps">
                    {{ slotProps.data.meta.make }}
                </template>
            </Column>
            <Column field="meta.model" header="Model" sortable>
                <template #body="slotProps">
                    {{ slotProps.data.meta.model }}
                </template>
            </Column>
            <Column field="meta.description" header="Description" sortable>
                <template #body="slotProps">
                    {{ slotProps.data.meta.description }}
                </template>
            </Column>
            <Column field="meta.install_date" header="Install Date" sortable :exportFormatFn="true">
                <template #body="slotProps">
                    {{ slotProps.data.meta.install_date }}
                </template>
            </Column>
            <Column field="meta.warranty" header="Warranty" sortable>
                <template #body="slotProps">
                    {{ slotProps.data.meta.warranty }}
                </template>
            </Column>
            <Column field="meta.warranty_exp_date" header="Warranty Expiry Date" sortable :exportFormatFn="true">
                <template #body="slotProps">
                    {{ slotProps.data.meta.warranty_exp_date }}
                </template>
            </Column>
            <Column field="pass" header="Pass/Fail Status" :sortable="true">
                <template #body="slotProps">
                    <span v-if="slotProps.data.pass">{{ slotProps.data.pass }}</span>
                </template>
            </Column>
            <Column field="notes" header="Notes" :sortable="true">
                <template #body="slotProps">
                    <span v-if="slotProps.data.notes">{{ slotProps.data.notes }}</span>
                </template>
            </Column>
            <Column field="datetime" header="Last Updated" :sortable="true" :exportFormatFn="true">
                <template #body="slotProps">
                    {{ slotProps.data.datetime }}
                </template>
            </Column>
        </DataTable>
        <!-- EXPORT ASSET DATA REF END -->
        <div class="p-col-12">
            <div class="card">
                <h4 v-if="client && client.key && site && site.key" class="p-d-flex p-ai-baseline">
                    <router-link icon="pi pi-angle-left" class="p-button p-button-icon p-mr-4" v-if="client && client.key" :to="{ name: 'site', params: { client_id: client.key, id: site.key } }">
                        <i class="pi pi-angle-left"></i>
                        Back
                    </router-link>
                    <span>
                        <router-link :to="{ name: 'sites', params: { id: client.key } }">{{ client.name }}</router-link> /
                        <router-link :to="{ name: 'site', params: { client_id: client.key, id: site.key } }">{{ site.name
                            }}</router-link> /
                        Site Activity Log
                    </span>
                </h4>
                <DataTable :exportFilename="exportName()" ref="dt" :value="logs" class="p-datatable-customers" :rows="10" dataKey="id" :loading="false" id="print">
                    <template #header>
                        <div class="p-d-flex p-jc-between">
                            <div style="text-align: left">
                                <Button icon="pi pi-external-link" label="Export Activity Log" @click="exportSiteCSV($event)" />
                            </div>
                            <!-- <div>
                                <Button icon="pi pi-print" label="Print" @click="print($event)" />
                            </div> -->
                            <!-- <span class="loading_export">
                                <Button icon="pi pi-external-link" label="Export Asset Status Data"
                                :disabled="assetExportLoading" @click="exportAssetCSV($event)" />
                                <i v-if="assetExportLoading" class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>
                            </span> -->
                            <!-- TEMP REMOVAL ^ -->

                        </div>
                    </template>
                    <template #empty>
                        No logs found.
                    </template>
                    <template #loading>
                        Loading activity data. Please wait.
                    </template>
                    <Column field="data.site_name" header="Site Name">
                        <template #body="slotProps">
                            {{ slotProps.data.data.site_name }}
                        </template>
                    </Column>
                    <Column field="data.datetime" header="When" :sortable="true" :exportFormatFn="true">
                        <template #body="slotProps">
                            {{ format_date(slotProps.data.data.timestamp.seconds * 1000) }}
                        </template>
                    </Column>
                    <Column field="data.full_name" header="Full Name" :sortable="true">
                        <template #body="slotProps">
                            {{ slotProps.data.data.full_name }}
                        </template>
                    </Column>
                    <Column field="data.company" header="Company" :sortable="true">
                        <template #body="slotProps">
                            {{ slotProps.data.data.company }}
                        </template>
                    </Column>
                    <Column field="name" header="Status">
                        <template #body="slotProps">
                            {{ slotProps.data.name }}
                        </template>
                    </Column>
                </DataTable>
                <!-- <Paginator :rows="limit" :totalRecords="siteAttendance.length" @page="updatePage"></Paginator> -->
            </div>
        </div>
    </div>
</template>

<script>
import { db } from '@/firebase';
import moment from 'moment';

export default {
    data() {
        return {
            count: 0,
            logs: [],
            pages: [],
            siteAttendance: [],
            client: [],
            site: [],
            assetInfo: [],
            assetIds: [],
            latestAsset: [],
            latestAssets: [],
            disabled: true,
            assetExportLoading: true,
        }
    },
    firestore() {
        return {
            siteAttendance: db.collection('attendance').where('client_id', '==', this.$route.params.client_id).where('site_id', '==', this.$route.params.id),
            site: db.collection('sites').doc(this.$route.params.id),
            client: db.collection('clients').doc(this.$route.params.client_id),
        }
    },
    mounted() {
        this.updatePage({ page: 0 });
        this.addRef();
    },
    methods: {
        exportName() {

            let clientName = this.client.name;
            let siteName = this.site.name;
            let currentDate = moment(new Date()).format('YYYY-MM-DD');

            return clientName + '-' + siteName + '-' + currentDate;
        },
        addRef() {
            let assetInfo = [];
            let latestAsset = [];
            assetInfo = db.collection('attendance').where('client_id', '==', this.$route.params.client_id).where('site_id', '==', this.$route.params.id).orderBy('timestamp', 'desc');

            assetInfo.get().then((docSnapshots) => {
                docSnapshots.forEach(doc => {
                    let data = doc.data();
                    this.assetIds.push(data.asset_id)
                });
                this.assetIds = [...new Set(this.assetIds)];
                let iterator = 0;

                this.assetIds.forEach(element => {

                    latestAsset = db.collection('attendance').where('pass', 'in', ['Fail', 'Pass', 'Fault']).where('asset_id', '==', element).orderBy('timestamp', 'desc').limit(1);

                    latestAsset.get().then((docSnapshots) => {
                        iterator++;
                        docSnapshots.forEach(doc => {
                            let data = doc.data();
                            this.latestAssets.push(data);

                            if (iterator == this.assetIds.length - 1) {
                                this.assetExportLoading = false;
                            }
                        });
                    });
                });

                this.disabled == false;

            });
        },
        format_date(value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY @ hh:mma')
            }
        },
        exportSiteCSV() {
            this.$refs.dt.exportCSV();
        },
        exportAssetCSV() {
            // this.$refs.siteAssets.exportCSV();

            // console.log(this.$refs)
            let csvContent = "data:text/csv;charset=utf-8, ID, Site Name, Location, Area, Category, Make, Model, Description, Install Date, Warranty, Warranty Expiry Date, Inspected By, Company, Pass/Fail Status, Notes, Last Updated \r\n",
                iterator = 0,
                rowValues,
                rowTotal = this.$refs.siteAssets.value.length;

            this.$refs.siteAssets.value.forEach(function (rowObject) {
                let install_date,
                    warranty_expiry_date,
                    rowValues,
                    // site_name,
                    rowArray = [];


                iterator++;

                (rowObject.meta.install_date) ? install_date = moment(rowObject.meta.install_date.seconds * 1000).format('DD/MM/YYYY @ hh:mma') : null;
                (rowObject.meta.warranty_expiry_date) ? warranty_expiry_date = moment(rowObject.meta.warranty_expiry_date.seconds * 1000).format('DD/MM/YYYY @ hh:mma') : null;

                rowValues = [rowObject.meta.asset_id, rowObject.site_name, rowObject.meta.location, rowObject.meta.area, rowObject.meta.category, rowObject.meta.make, rowObject.meta.model, rowObject.meta.description, install_date, rowObject.meta.warranty, warranty_expiry_date, rowObject.full_name, rowObject.company, rowObject.pass, rowObject.notes, rowObject.datetime];

                if (rowValues) {
                    rowValues = rowValues.join(',')
                    rowArray.push(rowValues)
                    // console.log(rowValues);
                    let row = rowArray.join(",");
                    csvContent += row + "\r\n";
                }


                if (iterator == rowTotal) { // if 
                    var encodedUri = encodeURI(csvContent);
                    encodedUri = encodedUri.replaceAll('#', '%23'); // hashes breaks csv generation, convert to unicode
                    let currentDate = moment(new Date()).format('YYYY-MM-DD');

                    const anchor = document.createElement('a');
                    anchor.href = encodedUri;
                    anchor.target = '_blank';
                    anchor.download = 'assetStatusExport-' + currentDate + '.csv';
                    anchor.click();
                }
            });
        },
        print() {
            window.print();
        },
        updatePage(e) {
            let start = this.pages[e.page] != undefined ? this.pages[e.page].timestamp : 0;
            let logs = [];
            if (!this.logs.length) {
                logs = db.collection('attendance')
                    .where('client_id', '==', this.$route.params.client_id)
                    .where('site_id', '==', this.$route.params.id)
                    .orderBy('timestamp', 'desc')
                    .limit(this.limit);
            } else {
                if (start == 0) {
                    logs = db.collection('attendance')
                        .orderBy('timestamp', 'desc')
                        .startAfter(this.logs[this.logs.length - 1].timestamp)
                        .where('client_id', '==', this.$route.params.client_id)
                        .where('site_id', '==', this.$route.params.id)
                        .limit(this.limit);
                } else {
                    logs = db.collection('attendance')
                        .orderBy('timestamp', 'desc')
                        .startAt(start).limit(this.limit)
                        .where('client_id', '==', this.$route.params.client_id)
                        .where('site_id', '==', this.$route.params.id)
                        .limit(this.limit);
                }
            }

            logs.get().then((logSnapshots) => {
                this.logs = [];
                let data = ''
                logSnapshots.forEach(doc => {
                    data = { data: doc.data(), name: doc.data().checked.name };
                    this.logs.push(data);
                });
                if (this.pages[e.page] == undefined) {
                    this.pages.push(this.logs[0]);
                }
            });
        }
    },
}
</script>

<style lang="scss">
@media print {
    #print button {
        display: none;
    }
}

.loading_export {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}
</style>
